import { createContext } from "react";

const emptyContext = createContext(true);

export { emptyContext };
